import React, {useEffect, useState} from "react";
import "../headSectionComponent.scss";
import {NavLink} from "react-router-dom";
import HeadSectionLogo from "./HeadSectionLogo";
import {useDispatch, useSelector} from "react-redux";
import Dropdown from "react-dropdown";
import AuthModal from "../../../sections/authSection/AuthModal";
import {RootState} from "../../../reducers/store";
import {UseLogout} from "../../../api/useAuth";
import Drawer from "@mui/material/Drawer";
import { setUserValue } from "../../../reducers/userReducer";
import { useTranslation } from "react-i18next";
import i18n, { languagesOption, STORE_LANGUAGE_KEY } from "../../../localization/i18n";

export default function Navbar() {
    const dispatch = useDispatch();
    const user = useSelector((state: RootState) => state.user);
    const { t } = useTranslation();
    const { language } = i18n;
    
    const [showNavMenu, setShowNavMenu] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [authType, setAuthType] = useState('' as string);
    
    const [width, setWidth]   = useState(window.innerWidth);
    
    const updateDimensions = () => {
        setWidth(window.innerWidth);
    }
    useEffect(() => {
        window.addEventListener("resize", updateDimensions);
        return () => window.removeEventListener("resize", updateDimensions);
    }, []);
    
    useEffect(() => {
        const setLang = (lng: string) => {
            i18n.changeLanguage(lng).then(() => {
                document.documentElement.lang = lng;
            });
        };
        
        const storedLanguage = localStorage.getItem(STORE_LANGUAGE_KEY);
        
        if (storedLanguage) {
            setLang(storedLanguage);
        } else {
            setLang('no');
        }
    }, [i18n]);
    
    const changeLanguage = (lng: string) => {
        i18n.changeLanguage(lng).then(() => {
            localStorage.setItem(STORE_LANGUAGE_KEY, lng);
            document.documentElement.lang = lng;
        });
    };

    const toggleNavMenu = (newOpen: boolean) => {
        //hideCustomNavbarDisplay();
        //setModalVisible(false);
        setShowNavMenu(newOpen);
        //const mainSection = document.querySelector('.mainSectionComponent__container-content-overlay');
        //if (mainSection) {
        //    mainSection.classList.toggle('active');
        //}
    }

    const handleCloseForm = (status: boolean) => {
        setModalVisible(false);

        if (status) {
            
            // setIsAuthUser(status);

            /*const mainSection = document.querySelector('.mainSectionComponent__container-content-login');
            if (mainSection) {
                mainSection.classList.remove('active');
            }
            setModalVisible(false);*/
            //setLoginSectionVisible(false);
        } else {

        }

        //setRegistrationSectionVisible(false);
    }

    const showCustomNavbarDisplay = () => {
        // const navElements = document.querySelector('.authNavbar__container-nav-elements');
        const navLogo = document.querySelector('.authNavbar__container-logo');

        if (navLogo) {
            //navElements.setAttribute('style', 'z-index: 1301');
            navLogo.setAttribute('style', 'z-index: 1301');
        }
    }

    const closeToggleNavMenu = () => {
        setShowNavMenu(false);
        const mainSectionNav = document.querySelector('.mainSectionComponent__container-content-overlay');
        if (mainSectionNav) {
            mainSectionNav.classList.remove('active');
        }
    }

    const handleLogin = (type: string) => {
        setAuthType(type);
        closeToggleNavMenu();
        setModalVisible(true);
        showCustomNavbarDisplay();
    }

    const handleLogout = () => {
        setModalVisible(false);
        UseLogout().then((response: any) => {
            console.log("response: ", response);
            dispatch(setUserValue({ key: "id", value: "" }));
            dispatch(setUserValue({ key: "name", value: "" }));
            dispatch(setUserValue({ key: "email", value: "" }));
            dispatch(setUserValue({ key: "phoneNr", value: "" }));
            dispatch(setUserValue({ key: "isAuth", value: false }));
            dispatch(setUserValue({ key: "cartCount", value: 0 }));
            dispatch(setUserValue({ key: "qrCodeCount", value: 0 }));
            dispatch(setUserValue({ key: "address", value: "" }));
        })
    }


    const scrollToBlock = (blockClass: string) => {
        const block = document.querySelector(`.${blockClass}`);
        if (block) {
            block.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <div className={`authNavbar__container ${modalVisible ? 'login-visible' : ''}`}>
            <div className="authNavbar__container_content">
                <HeadSectionLogo />
                {
                    user.isAuth ? (
                        <div className={`authNavbarComponent__container`}>
                            <ul className="authNavbarComponent__container_list">
                                <li>
                                    <NavLink to="/profile" >
                                        <img
                                          src={process.env.PUBLIC_URL + '/images/accountIcon.svg'}
                                          alt="account icon"
                                        />
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink to="/cart" >
                                        <div className="authNavbarComponent__container_close_icon cart">
                                            <img
                                              src={process.env.PUBLIC_URL + '/images/shopping-cart.svg'}
                                              alt="cart icon"
                                            />
                                            <div className={`authNavbarComponent__container_close_icon_counter ${user?.cartCount > 9 ? 'large' : ''}`}>
                                                <span>{user?.cartCount || 0}</span>
                                            </div>
                                        </div>
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink to="/my-codes" >
                                        <div className="authNavbarComponent__container_close_icon qr">
                                            <img
                                              className="authNavbar__container-nav-elements-img-qr-code"
                                              src={process.env.PUBLIC_URL + '/images/qr-code.svg'}
                                              alt="qr code icon"
                                            />
                                            <div className={`authNavbarComponent__container_close_icon_counter ${user?.qrCodeCount > 9 ? 'large' : ''}`}>
                                                <span>{user?.qrCodeCount || 0}</span>
                                            </div>
                                        </div>
                                    </NavLink>
                                </li>
                                <li>
                                    <div className="authNavbarComponent__container_languages dropdown">
                                        <Dropdown
                                          className="authNavbarComponent__container_languages_dropdown"
                                          arrowClosed={
                                              <div className="authNavbarComponent__container_languages_dropdown_icon close">
                                                  <img
                                                    src={process.env.PUBLIC_URL + "/images/language-select-arrow.svg"}
                                                    alt="arrow closed"
                                                  />
                                              </div>
                                          }
                                          arrowOpen={
                                              <div className="authNavbarComponent__container_languages_dropdown_icon open">
                                                  <img
                                                    src={process.env.PUBLIC_URL + "/images/language-select-arrow.svg"}
                                                    alt="sort up icon"
                                                  />
                                              </div>
                                          }
                                          options={languagesOption}
                                          onChange={(e) => changeLanguage(e.value)}
                                          value={language}
                                        />
                                    </div>
                                </li>
                                <li className="authNavbarComponent__container_auth">
                                    <img
                                      className="authNavbar__container-nav-menu-icon-img"
                                      src={process.env.PUBLIC_URL + '/images/burgerMenu.svg'}
                                      alt="burger menu icon"
                                      onClick={() => toggleNavMenu(true)}
                                    />
                                </li>
                            </ul>
                        </div>
                    ) : (
                      <div className={`notAuthNavbarComponent__container`}>
                          <ul className={`notAuthNavbarComponent__container_list`}>
                              <li>
                                  <NavLink to="/how-it-works"
                                           onClick={() => {
                                               //scrollToBlock('linkSection__container');
                                               closeToggleNavMenu();
                                           }}
                                  >{t('navbar.howItWorks')}</NavLink>
                              </li>
                              <li>
                                  <NavLink to="/food" >{t('navbar.food')}</NavLink>
                              </li>
                              <li>
                                  <NavLink to="/mobile-app"
                                           onClick={() => {
                                               // scrollToBlock('mobileAppSectionComponent__container');
                                               closeToggleNavMenu();
                                           }}
                                  >{t('navbar.mobileApp')}</NavLink>
                              </li>
                              <li>
                                  <NavLink to="/contact-us"
                                           onClick={() => {
                                               // scrollToBlock('contactSectionComponent__container');
                                               closeToggleNavMenu();
                                           }}
                                  >{t('navbar.contactUs')}</NavLink>
                              </li>
                              <li>
                                  <div className="authNavbarComponent__container_languages dropdown">
                                      <Dropdown
                                        className="authNavbarComponent__container_languages_dropdown"
                                        arrowClosed={
                                            <div className="authNavbarComponent__container_languages_dropdown_icon close">
                                                <img
                                                  src={process.env.PUBLIC_URL + "/images/language-select-arrow.svg"}
                                                  alt="arrow closed"
                                                />
                                            </div>
                                        }
                                        arrowOpen={
                                            <div className="authNavbarComponent__container_languages_dropdown_icon open">
                                                <img
                                                  src={process.env.PUBLIC_URL + "/images/language-select-arrow.svg"}
                                                  alt="arrow opened"
                                                />
                                            </div>
                                        }
                                        options={languagesOption}
                                        onChange={(e) => changeLanguage(e.value)}
                                        value={language}
                                      />
                                  </div>
                              </li>
                              <li>
                                  <NavLink
                                    to="/#"
                                    onClick={() => handleLogin('registration')}
                                  >
                                      {t('navbar.signUp')}
                                  </NavLink>
                              </li>
                              <li>
                                  <NavLink
                                    to="/#"
                                    onClick={() => handleLogin('login')}
                                  >
                                      {t('navbar.logIn')}
                                  </NavLink>
                              </li>
                              <li className="notAuthNavbarComponent__container_list_burger">
                                  <img
                                    className="authNavbar__container-nav-menu-icon-img"
                                    src={process.env.PUBLIC_URL + '/images/burgerMenu.svg'}
                                    alt="burger menu icon"
                                    onClick={() => toggleNavMenu(true)}
                                  />
                              </li>
                          </ul>
                      </div>
                    )
                }
                
                <Drawer
                  anchor={'right'}
                  open={showNavMenu}
                  onClose={() => toggleNavMenu(false)}
                  className="headSidebar"
                >
                    <div className="headSidebar__container">
                        {
                            user.isAuth && width > 424 ? (
                                <ul className={`headSidebar__container_content auth`}>
                                    <li className={`${user?.address ? 'active' : 'default'}`} style={{ animationDelay: "0s" }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M12 21C12 21 18 14.7 18 9C18 5.68629 15.3137 3 12 3C8.68629 3 6 5.68629 6 9C6 14.7 12 21 12 21Z" stroke="#8E8E8E"/>
                                            <path fillRule="evenodd" clipRule="evenodd" d="M12 10C12.5523 10 13 9.55228 13 9C13 8.44772 12.5523 8 12 8C11.4477 8 11 8.44772 11 9C11 9.55228 11.4477 10 12 10Z" stroke="#8E8E8E"/>
                                        </svg>
                                        <span>{user?.address || "street name"}</span>
                                    </li>
                                    <li style={{ animationDelay: "0s" }}>
                                        <NavLink to="/how-it-works"
                                                 onClick={() => {
                                                     //scrollToBlock('linkSection__container');
                                                     closeToggleNavMenu();
                                                 }}
                                        >{t('navbar.howItWorks')}</NavLink>
                                    </li>
                                    <li style={{ animationDelay: "0.2s" }}>
                                        <NavLink to="/food" >{t('navbar.food')}</NavLink>
                                    </li>
                                    <li style={{ animationDelay: "0.4s" }}>
                                        <NavLink to="/help-with-order" >{t('navbar.helpWithOrder')}</NavLink>
                                    </li>
                                    <li style={{ animationDelay: "0.6s" }}>
                                        <NavLink to="/contact-us" >{t('navbar.contactUs')}</NavLink>
                                    </li>
                                    <li style={{ animationDelay: "0.8s" }}>
                                        <NavLink
                                          to="/"
                                          onClick={handleLogout}
                                        >{t('navbar.logOut')}</NavLink>
                                    </li>
                                </ul>
                              )
                              :
                              user.isAuth && width < 425 ? (
                                  <ul className={`headSidebar__container_content auth`}>
                                      <li className={`${user?.address ? 'active' : 'default'}`} style={{ animationDelay: "0s" }}>
                                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                              <path fillRule="evenodd" clipRule="evenodd" d="M12 21C12 21 18 14.7 18 9C18 5.68629 15.3137 3 12 3C8.68629 3 6 5.68629 6 9C6 14.7 12 21 12 21Z" stroke="#8E8E8E"/>
                                              <path fillRule="evenodd" clipRule="evenodd" d="M12 10C12.5523 10 13 9.55228 13 9C13 8.44772 12.5523 8 12 8C11.4477 8 11 8.44772 11 9C11 9.55228 11.4477 10 12 10Z" stroke="#8E8E8E"/>
                                          </svg>
                                          <span>{user?.address || "street name"}</span>
                                      </li>
                                      <li style={{ animationDelay: "0s" }}>
                                          <NavLink to="/profile"
                                                   onClick={() => {
                                                       //scrollToBlock('linkSection__container');
                                                       closeToggleNavMenu();
                                                   }}
                                          >{t('navbar.profile')}</NavLink>
                                      </li>
                                      <li style={{ animationDelay: "0.1s" }}>
                                          <NavLink to="/cart" >Cart
                                              <div className={`authNavbarComponent__container_close_icon_counter ${user?.cartCount > 9 ? 'large' : ''}`}>
                                                  <span>{user?.cartCount || 0}</span>
                                              </div>
                                          </NavLink>
                                      </li>
                                      <li style={{ animationDelay: "0.2s" }}>
                                          <NavLink to="/my-codes" >
                                              {t('navbar.myCodes')}
                                              <div className={`authNavbarComponent__container_close_icon_counter ${user?.qrCodeCount > 9 ? 'large' : ''}`}>
                                                  <span>{user?.qrCodeCount || 0}</span>
                                              </div>
                                          </NavLink>
                                      </li>
                                      <li style={{ animationDelay: "0.3s" }}>
                                          <NavLink to="/how-it-works"
                                                   onClick={() => {
                                                       //scrollToBlock('linkSection__container');
                                                       closeToggleNavMenu();
                                                   }}
                                          >{t('navbar.howItWorks')}</NavLink>
                                      </li>
                                      <li style={{ animationDelay: "0.4s" }}>
                                          <NavLink to="/food" >{t('navbar.food')}</NavLink>
                                      </li>
                                      <li style={{ animationDelay: "0.5s" }}>
                                          <NavLink to="/help-with-order" >{t('navbar.helpWithOrder')}</NavLink>
                                      </li>
                                      <li style={{ animationDelay: "0.6s" }}>
                                          <NavLink to="/contact-us" >{t('navbar.contactUs')}</NavLink>
                                      </li>
                                      <li style={{ animationDelay: "0.7s" }}>
                                          <NavLink
                                            to="/"
                                            onClick={handleLogout}
                                          >{t('navbar.logOut')}</NavLink>
                                      </li>
                                  </ul>
                                )
                              :
                              (
                                <ul className={`headSidebar__container_content notAuth`}>
                                    <li className={`${user?.address ? 'active' : 'default'}`} style={{ animationDelay: "0s" }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M12 21C12 21 18 14.7 18 9C18 5.68629 15.3137 3 12 3C8.68629 3 6 5.68629 6 9C6 14.7 12 21 12 21Z" stroke="#8E8E8E"/>
                                            <path fillRule="evenodd" clipRule="evenodd" d="M12 10C12.5523 10 13 9.55228 13 9C13 8.44772 12.5523 8 12 8C11.4477 8 11 8.44772 11 9C11 9.55228 11.4477 10 12 10Z" stroke="#8E8E8E"/>
                                        </svg>
                                        <span>{user?.address || "street name"}</span>
                                    </li>
                                    <li style={{ animationDelay: "0s" }}>
                                        <NavLink to="/how-it-works"
                                                 onClick={() => {
                                                     //scrollToBlock('linkSection__container');
                                                     closeToggleNavMenu();
                                                 }}
                                        >{t('navbar.howItWorks')}</NavLink>
                                    </li>
                                    <li style={{ animationDelay: "0.2s" }}>
                                        <NavLink to="/food" >{t('navbar.food')}</NavLink>
                                    </li>
                                    <li style={{ animationDelay: "0.4s" }}>
                                        <NavLink to="/contact-us"
                                                 onClick={() => {
                                                     // scrollToBlock('contactSectionComponent__container');
                                                     closeToggleNavMenu();
                                                 }}
                                        >{t('navbar.contactUs')}</NavLink>
                                    </li>
                                    <li style={{ animationDelay: "0.6s" }}>
                                        <a onClick={() => handleLogin('login')}>
                                            {t('navbar.logIn')}
                                        </a>
                                    </li>
                                    <li style={{ animationDelay: "0.8s" }}>
                                        <a onClick={() => handleLogin('registration')}>
                                            {t('navbar.signUp')}
                                        </a>
                                    </li>
                                </ul>
                              )
                        }
                        <div className="headSidebar__container_close">
                            <img
                              src={process.env.PUBLIC_URL + '/images/close.svg'}
                              alt="burger menu icon"
                              onClick={() => toggleNavMenu(false)}
                            />
                        </div>
                    </div>
                </Drawer>
            </div>
            <div className="authNavbar__loginSectionComponent_container">
                <AuthModal
                    authStatus={user.isAuth}
                    isVisible={modalVisible}
                    setIsVisible={(status: boolean) => setModalVisible(status)}
                    handleAuthModal={(authUser: boolean) => handleCloseForm(authUser)}
                    authType={authType}
                    setAuthType={(type: string) => setAuthType(type)}
                />
            </div>
            {/*<div className="authNavbar__registrationSectionComponent_container">
                {registrationSectionVisible &&
                    <RegistrationSectionComponent
                        handleRegistration={(authUser: boolean) => handleCloseForm(authUser)}
                    />
                }
            </div>*/}
        </div>
    );
}